import { c as _c } from "react/compiler-runtime";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@achra/ui/empty';
import { cn } from '@achra/ui/lib/utils';
import { FileX } from 'lucide-react';
interface EmptyTablePlaceholderProps {
  /** Builder or actor name/code shown in the message */
  actorName: string;
  /** Whether to show the border outline. @default true */
  showBorder?: boolean;
}
function EmptyTablePlaceholder(t0) {
  const $ = _c(9);
  const {
    actorName,
    showBorder: t1
  } = t0;
  const showBorder = t1 === undefined ? true : t1;
  const t2 = showBorder && "border border-solid";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("bg-background w-full md:p-6", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <EmptyMedia variant="icon"><FileX /></EmptyMedia>;
    t5 = <EmptyTitle>No Expense Reports Data</EmptyTitle>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  let t6;
  if ($[4] !== actorName) {
    t6 = <EmptyHeader>{t4}{t5}<EmptyDescription>There's no Expense Reports data reported by {actorName}.</EmptyDescription></EmptyHeader>;
    $[4] = actorName;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t6) {
    t7 = <Empty className={t3}>{t6}</Empty>;
    $[6] = t3;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}
export { EmptyTablePlaceholder };